import React, { createContext, PropsWithChildren, useContext } from "react";

const OutlookContext = createContext(false);

export function OutlookProvider({
  children,
  isOutlook,
}: PropsWithChildren<{ isOutlook: boolean }>) {
  return <OutlookContext.Provider value={isOutlook}>{children}</OutlookContext.Provider>;
}

/**
 * This hook is used to get the current isOutlook value from OutlookProvider Context.
 */
export function useIsOutlook() {
  return useContext(OutlookContext);
}
